import { render, staticRenderFns } from "./ClientApiCalls.vue?vue&type=template&id=48098a02&scoped=true"
import script from "./ClientApiCalls.vue?vue&type=script&lang=js"
export * from "./ClientApiCalls.vue?vue&type=script&lang=js"
import style0 from "./ClientApiCalls.vue?vue&type=style&index=0&id=48098a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48098a02",
  null
  
)

export default component.exports